exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-header[data-v-b50ef614] {\n  padding: 10px 20px;\n}\n", ""]);

// exports
